/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Create_Project_Name_MinInputs */



/**
* | output |
* | --- |
* | "Project name must be at least {count} characters" |
*
* @param {Create_Project_Name_MinInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const create_project_name_min = /** @type {((inputs: Create_Project_Name_MinInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Project_Name_MinInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Projektname muss mindestens ${i?.count} Zeichen lang sein`)
	return /** @type {LocalizedString} */ (`Project name must be at least ${i?.count} characters`)
});